// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1Yhji","info":"Note_info__2vMXk","note":"Note_note__3Br5r","actions":"Note_actions__OIL6I"};